import React from 'react';

const TablePager = ({pages, page, firstPage, lastPage, onChangePage, values=10}) => (
    <div className="ui right floated pagination menu">


        {
            page <= firstPage ? (
                <a className="icon item disabled"><i className="chevron circle left large icon"></i></a>
            ): (<a className="icon item" onClick={() => onChangePage(firstPage)} title="Prima pagina"><i className="chevron circle left large icon"></i></a>)
        }

        {
            page <= firstPage ? (
                    <a className="icon item disabled">
                        <i className="left chevron icon"></i>
                    </a>) : (<a className="icon item" onClick={() => onChangePage('P')} title="Pagina precedente">
                    <i className="left chevron icon"></i>
                </a>)
        }

        {
            pages.length <= values ?

                pages.map((i) => (
                    i === page ? (
                            <a key={i} className="item disabled">{i}</a>)
                        : (
                            <a key={i}
                               className="item"
                               onClick={() => onChangePage(i)}
                            >{i}</a>)
                ))

            :

                pages.filter((i)=>(i>= page-values/2 && i <= page + values/2)).map((i) => (
                    i === page ? (
                            <a key={i} className="item disabled">{i}</a>)
                        : (
                            <a key={i}
                               className="item"
                               onClick={() => onChangePage(i)}
                            >{i}</a>)
                ))
        }
        {
            page >= lastPage ? (
                    <a className="icon item disabled">
                        <i className="right chevron icon"></i>
                    </a>
                ):(
                    <a className="icon item" onClick={() => onChangePage('N')} title="Pagina successiva">
                        <i className="right chevron icon"></i>
                    </a>
                )
        }

        {
            page >= lastPage ? (
                <a className="icon item disabled"><i className="chevron circle right large icon"></i></a>
            ):(
                <a className="icon item" onClick={() => onChangePage(lastPage)} title="Ultima pagina"><i className="chevron circle right large icon"></i></a>
            )
        }

    </div>
)

export default TablePager


/** WEBPACK FOOTER **
 ** ./src/components/TablePager.jsx
 **/